module.exports = __webpack_public_path__ + "static/img/role.60d247b.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/feature/role.png
// module id = ZtaN
// module chunks = 7